import AgeSelector from "./AgeSelector";
export default AgeSelector;